export const SCORE_LABELS = {
  redditivita: "Redditività",
  facilita: "Facilità di avvio",
  concorrenza: "Bassa concorrenza",
  scalabilita: "Scalabilità",
  rischio: "Basso rischio",
};

export const scoreTone = (v) =>
  v >= 7.5 ? "emerald" : v >= 5 ? "amber" : "rose";

const BAR = { emerald: "bg-emerald-400", amber: "bg-amber-400", rose: "bg-rose-400" };
const BADGE = {
  emerald: "text-emerald-300 bg-emerald-500/10 border-emerald-500/30",
  amber: "text-amber-300 bg-amber-500/10 border-amber-500/30",
  rose: "text-rose-300 bg-rose-500/10 border-rose-500/30",
};

export const OverallScore = ({ value, testId }) => {
  const v = Number(value) || 0;
  return (
    <div className={`shrink-0 w-16 h-16 rounded-2xl border grid place-items-center ${BADGE[scoreTone(v)]}`} data-testid={testId}>
      <div className="text-center leading-none">
        <div className="font-display text-2xl font-bold">{v.toFixed(1)}</div>
        <div className="text-[10px] uppercase tracking-wider opacity-70 mt-1">/ 10</div>
      </div>
    </div>
  );
};

export const ScoreBars = ({ scores = {}, testPrefix }) => (
  <div className="space-y-2.5">
    {Object.entries(SCORE_LABELS).map(([k, label]) => {
      const v = Number(scores[k]) || 0;
      return (
        <div key={k} className="grid grid-cols-[1fr_auto] gap-x-3 gap-y-1 items-center" data-testid={`${testPrefix}-score-${k}`}>
          <span className="text-xs text-slate-400">{label}</span>
          <span className="font-mono text-xs text-slate-200">{v}</span>
          <div className="col-span-2 h-1.5 rounded-full bg-white/5 overflow-hidden">
            <div className={`h-full rounded-full ${BAR[scoreTone(v)]} transition-[width] duration-700`} style={{ width: `${v * 10}%` }} />
          </div>
        </div>
      );
    })}
  </div>
);
